import { render, staticRenderFns } from "./item.vue?vue&type=template&id=63f4a363&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
import style0 from "./item.vue?vue&type=style&index=0&id=63f4a363&prod&lang=less&scoped=true"
import style1 from "./item.vue?vue&type=style&index=1&id=63f4a363&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4a363",
  null
  
)

export default component.exports